import * as yup from 'yup'
import { ApplicationFormAnswers } from '../components/ApplicationForm/ApplicationFormContext'
import BaseValidator from './BaseValidator'

const phoneRegex = new RegExp(/^(((\+44\s?\d{4}|\(?0\d{4}\)?)\s?\d{3}\s?\d{3})|((\+44\s?\d{3}|\(?0\d{3}\)?)\s?\d{3}\s?\d{4})|((\+44\s?\d{2}|\(?0\d{2}\)?)\s?\d{4}\s?\d{4}))(\s?#(\d{4}|\d{3}))?$/, 'i')

const ContactNumberValidator = (): BaseValidator => {
  const schema = yup.object().shape({
    contactNumber: yup.string().matches(phoneRegex, {
      message: 'Please enter a valid telephone number',
      excludeEmptyString: true
    })
      .typeError('Please enter a valid telephone number')
      .required('Please enter your telephone number')
  })

  return {
    getValidator: () => schema,
    validateState: (state: ApplicationFormAnswers) => schema.isValidSync({
      contactNumber: state.contactNumber
    })
  }
}

export default ContactNumberValidator
